import React, {useRef} from 'react';
import {Button} from 'primereact/button';
import {Menu} from 'primereact/menu';
import {useNavigate} from "react-router-dom";
import {Avatar} from "primereact/avatar";
import GeneralUtils from "../../utils/GeneralUtils";

const ProfileMenu = (props) => {
    const {logout} = props;
    const refMenu = useRef(null);
    const navigate = useNavigate();

    const items = [
        {
            items: [
                // {
                //     label: 'Öğrenim İçeriğim',
                //     icon: 'pi pi-book',
                //     command: () => {
                //         navigate("/user/myCourses");
                //     }
                // },
                // {
                //     command: () => {
                //         navigate("/user/profile");
                //     },
                //     template: (item, options) => {
                //         return (
                //             <button onClick={(e) => options.onClick(e)}
                //                     className={options.className + ' w-full p-link flex align-items-center'}>
                //                 <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png"
                //                         className="mr-2" shape="circle"/>
                //                 <div className="flex flex-column align">
                //                     <span className="font-bold">Amy Elsner</span>
                //                     <span className="text-sm">Agent</span>
                //                 </div>
                //             </button>
                //         )
                //     }
                // },
                {
                    label: 'Profili Düzenle',
                    icon: 'pi pi-user-edit',
                    command: () => {
                        navigate("/user/profile");
                    }

                },
                {
                    label: 'Oturumu Kapat',
                    icon: 'pi pi-sign-out',
                    command: () => {
                        logout();
                        navigate("/");
                    }
                }
            ]
        }
    ];

    return (
        <Button icon={GeneralUtils.getUser().image200h ?
            <img src={GeneralUtils.getUser().image200h} alt="Image" width="60" className="instructor-image"
                 // onError={(e) => e.target.src = "/icons/user-empty2.png"}
            />
            : "pi pi-user"} rounded outlined
                onMouseEnter={(e) => refMenu.current.show(e)}
                onMouseLeave={(e) => refMenu.current.hide(e)} className="p-button-icon-only">
            <Menu model={items} breakpoint="767px" popup ref={refMenu}/>
        </Button>
    )
}
export default ProfileMenu;

